/**
 * Crop away fully-transparent padding so a logo renders at its true size —
 * many logo files ship with big invisible margins baked in. Falls back to
 * the original data URL if anything goes wrong (e.g. SVG input).
 */
const trimTransparentEdges = (dataUrl: string): Promise<string> => new Promise((resolve) => {
  if (!dataUrl.startsWith('data:image/') || dataUrl.startsWith('data:image/svg')) {
    resolve(dataUrl);
    return;
  }
  const img = new window.Image();
  img.onload = () => {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) { resolve(dataUrl); return; }
      ctx.drawImage(img, 0, 0);
      const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
      let top = canvas.height; let left = canvas.width; let right = 0; let bottom = 0;
      for (let y = 0; y < canvas.height; y += 1) {
        for (let x = 0; x < canvas.width; x += 1) {
          if (data[(y * canvas.width + x) * 4 + 3] > 8) {
            if (x < left) left = x;
            if (x > right) right = x;
            if (y < top) top = y;
            if (y > bottom) bottom = y;
          }
        }
      }
      if (right <= left || bottom <= top) { resolve(dataUrl); return; }
      const w = right - left + 1;
      const h = bottom - top + 1;
      const out = document.createElement('canvas');
      out.width = w;
      out.height = h;
      out.getContext('2d')?.drawImage(canvas, left, top, w, h, 0, 0, w, h);
      resolve(out.toDataURL('image/png'));
    } catch {
      resolve(dataUrl);
    }
  };
  img.onerror = () => resolve(dataUrl);
  img.src = dataUrl;
});

export default trimTransparentEdges;
